module.exports = __webpack_public_path__ + "img/woyaoyou_bg_phone@2x.7668ca9e.png";